export default __webpack_public_path__ + "b1dd942715ab9c160c56c316450fe8f4.gif";